import { Fragment, useEffect, useState } from "react";
import HomeLanding from "./homelanding/HomeLanding";
import PageLayout from "../../layouts/pagelayout/PageLayout";
import TrustedCompanies from "./trustedcompanies/TrustedCompanies";
import LetsHealp from "./letshelp/LetsHealp";
import HomeBiGridInfo from "./homebigridinfo/HomeBiGridInfo";
import Counters from "./counters/Counters";
import OurSolution from "./oursolution/OurSolution";
import Testimonials from "./testimonials/Testimonials";
import CaseStudy from "./casestudy/CaseStudy";
import ScrollTrigger from "react-scroll-trigger";
import WOW from "wow.js";
import SolutionSecondSec from "../solutions/solutionsecondsec/SolutionSecondSec";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl, getHome } from "../../utils/apiData";
import LoaderCard from "../../components/loaderCard/LoaderCard";

const Home = () => {
  const [theme, setTheme] = useState(true);
  const [loader, setLoader] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [caseStudy, setCaseStudy] = useState([]);
  const [client, setClient] = useState([]);
  const [offer, setOffer] = useState([]);
  const [homePage, setHomePage] = useState({});

  const navigate = useNavigate();
  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);

  const homePageApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getHome}`);
      if (res?.data?.success) {
        setBlogs(res?.data?.data?.blogs);
        setCaseStudy(res?.data?.data?.casestudy);
        setClient(res?.data?.data?.client);
        setOffer(res?.data?.data?.offer);
        setHomePage(res?.data?.data?.homepage);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    homePageApi();
  }, []);

  return (
    <Fragment>
      <PageLayout theme={theme}>
        {loader ? (
          <LoaderCard />
        ) : (
          <Fragment>
            <HomeLanding data={homePage} />
            <LetsHealp data={homePage} theme={theme} />
            <TrustedCompanies slideData={client} theme={theme} />

            <HomeBiGridInfo
              title={homePage?.section_2_title || "-"}
              para={homePage?.section_2_description || "-"}
              order={0}
              classList="p_top"
              img={homePage?.section_2_image}
            />
            <ScrollTrigger
              onEnter={() => setTheme(false)}
              onExit={() => setTheme(true)}
            >
              <HomeBiGridInfo
                title={homePage?.section_3_title || "-"}
                para={homePage?.section_3_description || "-"}
                order={-1}
                img={homePage?.section_3_image}
                btn="Know more"
                onClick={() => navigate("/about")}
              />

              <SolutionSecondSec
                title={homePage?.section_4_title || "-"}
                infoData={homePage?.section_4_points}
                iconList={homePage?.section_4_images}
              />
              <Counters data={homePage} />

              {/* Offerings */}
              <OurSolution dataList={offer} />

              {/* Case Studies */}
              <Testimonials dataList={caseStudy} />


              {/* Blogs HighLights */}
              <CaseStudy
                title={homePage?.blog_title}
                tag="Blog"
                data={blogs}
                btnTitle="See All Blogs"
                btnClick={() => navigate("blog")}
              />
            </ScrollTrigger>
          </Fragment>
        )}
      </PageLayout>
    </Fragment>
  );
};

export default Home;
